import { render, staticRenderFns } from "./ConsentsModal.vue?vue&type=template&id=7f336389&scoped=true&"
import script from "./ConsentsModal.vue?vue&type=script&lang=js&"
export * from "./ConsentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsentsModal.vue?vue&type=style&index=0&id=7f336389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f336389",
  null
  
)

export default component.exports